import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import helpers from 'src/styles/helpers';
import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  attachFileText: {
    maxWidth: '300px',
    textAlign: 'center'
  },
  attachFileButton: {
    marginTop: '20px'
  },
  dropArea: {
    width: '100%',
    height: '100%',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    transition: '0.2s',
    minHeight: '71px',
    fontSize: '17px',
    padding: '12px',
    textAlign: 'center',
    backgroundColor: "".concat(palette.shades[100]),
    '&:not(.active).drag': {
      backgroundColor: "".concat(palette.shades[200])
    },
    '&.active': {
      textAlign: 'left',
      '& input': {
        width: '1px',
        height: '1px'
      }
    },
    '& input': {
      top: '0',
      left: '0',
      opacity: '0',
      width: '100%',
      height: '100%',
      position: 'absolute',
      cursor: 'pointer',
      padding: '0',
      '&:focus': {
        outline: 'none'
      }
    },
    '&.disabled': {
      backgroundColor: "".concat(palette.shades[200]),
      opacity: '0.5',
      '& input': {
        cursor: 'auto'
      }
    }
  },
  /** Bill file drop zone — file drag-over (container keeps `.active` for layout). */
  dropAreaFileDragOver: {
    border: "2px dashed ".concat(palette.shades[600]),
    backgroundColor: "".concat(palette.shades[200]),
    boxShadow: "inset 0 0 0 1px ".concat(palette.shades[400])
  },
  contentTabs: {
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& .MuiTabs-root': {
      minHeight: '40px'
    },
    '& .MuiTab-root': {
      minHeight: '40px',
      padding: '0 16px',
      fontSize: '14px',
      textTransform: 'none'
    }
  },
  formTitle: {
    padding: '16px 24px 12px 24px'
  },
  modalWrapper: {
    display: 'flex'
  },
  modalEditor: {
    width: '50%',
    display: 'flex',
    padding: '24px',
    minHeight: '600px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.shades[200],
    borderRight: "1px solid ".concat(palette.shades[300]),
    '& > div': {
      height: '100%',
      width: '100%'
    },
    '&.isFile': {
      padding: '0'
    },
    '& .MuiBackdrop-root': {
      zIndex: '999'
    }
  },
  modalData: {
    width: '50%',
    flexShrink: '0',
    display: 'flex',
    flexWrap: 'wrap',
    backgroundColor: palette.common.white,
    alignItems: 'flex-start',
    alignContent: 'space-between',
    '& > div': {
      width: '100%',
      flexGrow: '1'
    }
  },
  billDetailsWrapper: {
    overflowY: 'auto',
    maxHeight: '450px'
  },
  tableWrapper: {
    overflow: 'auto',
    maxHeight: '560px',
    '& .MuiButton-actionButtonInvert': {
      minHeight: '28px'
    }
  },
  modalTitle: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiChip-root': {
      fontSize: '13px',
      padding: '0px 6px',
      marginLeft: '10px'
    }
  },
  modalPaper: {
    position: 'relative'
  },
  // Sits beside the modal's own close button, which SimpleModal renders in a header this content has
  // no way into — so it reaches up out of the paper, as the autosave line already does.
  //
  // A twin of that close button rather than a styled box: same IconButton at the same size, so the two
  // read as one pair of actions. Centred by transform rather than by a top offset that would have to
  // know the button's height, and placed one button-width plus a gap left of it (the close button
  // occupies 40px–88px from the right edge). Disabled it fades, so it stays legible as a control that
  // is simply not open to you.
  recoveredDeleteFloating: {
    top: '-54px',
    right: '92px',
    position: 'absolute',
    transform: 'translateY(-50%)',
    zIndex: 1,
    '& .Mui-disabled': {
      opacity: 0.35
    }
  },
  modalAutosaveFloating: {
    top: '-60px',
    right: '80px',
    position: 'absolute',
    color: palette.shades[600],
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16px',
    textTransform: 'lowercase',
    pointerEvents: 'none'
  },
  infoAndEdit: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '16px',
    backgroundColor: palette.shades[200],
    justifyContent: 'space-between',
    '& .MuiButton-root': {
      border: "1px solid ".concat(palette.shades[300]),
      '& svg': {
        marginRight: '4px'
      }
    }
  },
  infoWrapper: {
    display: 'flex',
    padding: '12px 0',
    fontFamily: palette.fontFamilies.poppins,
    '& dl': {
      margin: '0',
      padding: '0 16px',
      fontWeight: '600',
      '&:not(:first-child)': {
        borderLeft: "1px solid ".concat(palette.shades[300])
      }
    },
    '& dt': {
      color: palette.shades[700],
      fontSize: '13px'
    },
    '& dd': {
      color: palette.common.black,
      fontSize: '15px',
      margin: '0'
    }
  },
  billFile: {
    display: 'flex',
    borderRadius: '2px',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    padding: '6px 8px 6px 6px',
    border: "1px solid ".concat(palette.shades[300]),
    justifyContent: 'space-between'
  },
  billFileIcon: {
    width: '24px',
    height: '24px',
    flexShrink: '0',
    marginRight: '4px',
    borderRadius: '2px',
    border: "1px solid ".concat(palette.shades[300])
  },
  billFileTitle: {
    width: '100%',
    color: palette.primary.main,
    fontSize: '13px',
    fontWeight: '600'
  },
  billFileAction: {
    flexShrink: '0',
    marginLeft: '16px',
    '& .MuiButton-root': {
      padding: '0',
      width: '24px',
      height: '24px',
      border: 'none',
      backgroundColor: 'transparent'
    }
  },
  warningBlock: {
    display: 'flex',
    padding: '12px 16px',
    alignItems: 'flex-start',
    borderTop: "1px solid ".concat(palette.shades[300]),
    justifyContent: 'space-between',
    background: 'linear-gradient(180deg, #FFF3E1 0%, rgba(255, 243, 225, 0.00) 100%)',
    '& .MuiTypography-root': {
      color: palette.warning.dark
    },
    '& .MuiFormControlLabel-label': {
      color: palette.common.black,
      fontSize: '16px',
      marginRight: '8px'
    },
    '& > div:first-child': {
      paddingRight: '24px'
    }
  },
  sectionTitle: {
    color: palette.shades[700],
    fontSize: '13px',
    fontWeight: '600',
    padding: '0 24px 0 24px',
    fontFamily: palette.fontFamilies.poppins
  },
  deductionsBox: {
    marginTop: '10px',
    marginBottom: '10px',
    padding: '0 24px 0 24px'
  },
  sameAsAmountHint: {
    color: '#009299',
    marginTop: '4px',
    fontSize: '13px',
    fontWeight: '600'
  },
  deductionItem: {
    display: 'flex',
    lineHeight: '38px',
    borderRadius: '2px',
    alignItems: 'flex-start',
    backgroundColor: palette.shades[200],
    padding: '4px 4px 4px 12px',
    justifyContent: 'space-between',
    '&:not(:last-child)': {
      marginBottom: '4px'
    }
  },
  deductionItemData: {
    color: palette.shades[700],
    fontSize: '13px',
    fontWeight: '600',
    fontFamily: palette.fontFamilies.poppins,
    '& b': {
      color: palette.common.black
    }
  },
  deductionItemEdit: {},
  allocationTotal: {
    color: palette.shades[700],
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '27px',
    fontFamily: palette.fontFamilies.poppins,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '12px',
    padding: '0 24px 0 24px',
    marginBottom: '24px',
    '& b': {
      color: palette.common.black,
      marginLeft: '4px'
    }
  },
  serviceDate: {
    marginTop: '10px',
    marginBottom: '12px',
    padding: '0 24px 0 24px'
  },
  serviceDateInSplitRow: {
    '@media (min-width:900px)': {
      paddingRight: 8
    }
  },
  deductionsBoxInSplitRow: {
    '@media (min-width:900px)': {
      paddingLeft: 8
    }
  },
  /** Match sectionTitle left edge to deductionsBoxInSplitRow content (md+ split layout) */
  sectionTitleAmountsSplitAlign: {
    '@media (min-width:900px)': {
      paddingLeft: 8
    }
  },
  extractedBanner: {
    gap: '12px',
    display: 'flex',
    marginBottom: '12px',
    borderRadius: '2px',
    alignItems: 'center',
    padding: '10px 12px',
    justifyContent: 'space-between',
    backgroundColor: '#E9F8EE'
  },
  extractedBannerError: {
    backgroundColor: '#FEF2F2',
    border: "1px solid ".concat(palette.shades[300]),
    borderLeft: '3px solid #DC2626'
  },
  extractedBannerErrorTitle: {
    color: '#991B1B',
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '18px',
    fontFamily: palette.fontFamilies.poppins
  },
  extractedBannerErrorIntro: {
    color: palette.shades[800],
    fontSize: '12px',
    lineHeight: '16px',
    marginTop: '6px',
    fontFamily: palette.fontFamilies.poppins
  },
  extractedBannerErrorList: {
    margin: '8px 0 0 0',
    paddingLeft: '18px',
    fontFamily: palette.fontFamilies.poppins
  },
  extractedBannerErrorListItem: {
    color: palette.shades[900],
    fontSize: '12px',
    lineHeight: '18px',
    marginBottom: '4px',
    '&:last-child': {
      marginBottom: 0
    }
  },
  extractedBannerWarning: {
    backgroundColor: '#FFFBEB',
    border: "1px solid ".concat(palette.shades[300]),
    borderLeft: '3px solid #D97706'
  },
  // Wraps the recovered bill's document and the placeholder that stands in while its presigned URL is
  // being fetched. The document itself is drawn by the app's own viewer, which brings its own chrome.
  recoveredFilePane: {
    gap: '8px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  recoveredFilePlaceholder: {
    display: 'flex',
    minHeight: '480px',
    alignItems: 'center',
    justifyContent: 'center',
    color: palette.shades[600],
    border: "1px dashed ".concat(palette.shades[300]),
    borderRadius: '8px'
  },
  // Informational, not a success: the bill was not extracted just now, it was waiting. Blue keeps it
  // distinct from the green "AI extracted this bill" banner it can appear beside.
  recoveredBanner: {
    backgroundColor: '#EFF6FF',
    border: "1px solid ".concat(palette.shades[300]),
    borderLeft: '3px solid #2563EB',
    '& > div > div > div': {
      color: '#1E40AF'
    }
  },
  recoveredBannerNote: {
    color: '#1E40AF',
    fontSize: '12px',
    lineHeight: '16px',
    marginTop: '6px',
    fontStyle: 'italic',
    fontFamily: palette.fontFamilies.poppins
  },
  recoveredBannerIconWrap: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '20px',
      height: '20px',
      color: '#2563EB'
    }
  },
  recoveredBannerDismiss: {
    flexShrink: 0,
    alignSelf: 'flex-start',
    '& svg': {
      width: '14px',
      height: '14px',
      color: '#1E40AF'
    }
  },
  extractedBannerWarningTitle: {
    color: '#92400E',
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '18px',
    fontFamily: palette.fontFamilies.poppins
  },
  extractedBannerWarningIntro: {
    color: palette.shades[800],
    fontSize: '12px',
    lineHeight: '16px',
    marginTop: '6px',
    fontFamily: palette.fontFamilies.poppins
  },
  extractedBannerWarningList: {
    margin: '8px 0 0 0',
    paddingLeft: '18px',
    fontFamily: palette.fontFamilies.poppins
  },
  extractedBannerWarningListItem: {
    color: palette.shades[900],
    fontSize: '12px',
    lineHeight: '18px',
    marginBottom: '4px',
    '&:last-child': {
      marginBottom: 0
    }
  },
  extractedBannerLoadingOnly: {
    justifyContent: 'flex-start'
  },
  extractedBannerSpinnerWrap: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: '1px',
    marginRight: '8px',
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      width: '24px',
      height: '24px'
    }
  },
  extractedBannerContent: {
    display: 'flex',
    alignItems: 'flex-start',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
      marginTop: '1px',
      marginRight: '8px'
    }
  },
  extractedBannerSparkleIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: '1px',
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      width: '24px',
      height: '24px'
    },
    '& .MuiSvgIcon-root path': {
      fill: '#259D58'
    }
  },
  extractedBannerAiIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: '1px',
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      width: '24px',
      height: '24px'
    }
  },
  extractedBannerTitle: {
    color: '#106B21',
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '16px',
    fontFamily: palette.fontFamilies.poppins
  },
  extractedBannerText: {
    color: '#106B21',
    fontSize: '12px',
    lineHeight: '16px',
    marginTop: '2px'
  },
  extractedBannerStopButton: {
    marginLeft: 'auto',
    flexShrink: 0,
    minWidth: 'auto',
    padding: '4px 12px',
    height: '32px',
    borderRadius: '4px',
    color: palette.shades[700],
    fontSize: '13px',
    fontWeight: 600,
    textTransform: 'none',
    fontFamily: palette.fontFamilies.poppins,
    '&:hover': {
      color: palette.error.dark,
      backgroundColor: palette.error.light
    },
    '&:focus-visible': {
      color: palette.error.dark,
      backgroundColor: palette.error.light
    }
  },
  extractedBannerButton: {
    minWidth: '112px',
    padding: '6px 14px',
    height: '32px',
    borderRadius: '4px',
    boxShadow: 'none',
    backgroundColor: '#259D58',
    color: palette.common.white,
    fontSize: '13px',
    fontWeight: 600,
    textTransform: 'none',
    fontFamily: palette.fontFamilies.poppins,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#009299'
    }
  },
  serviceDateDatePicked: {
    '& > div': {
      width: '100%'
    },
    '& .react-datepicker-wrapper': {
      display: 'block',
      '& .MuiFormControl-root': {
        display: 'flex'
      }
    }
  },
  dueDatePickerWrapper: {
    position: 'relative'
  },
  dueDateInfoIcon: {
    top: '9px',
    right: '44px',
    zIndex: '2',
    padding: '2px',
    position: 'absolute'
  },
  amountInfoIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  extractedInput: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#E9F8EE',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#B6E2C1'
      }
    }
  },
  extractedValueHint: {
    color: '#106B21',
    fontSize: '12px',
    lineHeight: '16px',
    marginTop: '4px',
    fontWeight: '600',
    fontFamily: palette.fontFamilies.poppins
  },
  allocationWarning: {
    marginTop: '4px',
    padding: '0 24px 0 24px'
  },
  allocationWarningContent: {
    color: palette.warning.dark,
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    padding: '6px 10px',
    borderRadius: '2px',
    backgroundColor: palette.warning.light,
    fontFamily: palette.fontFamilies.poppins,
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      marginRight: '4px'
    }
  },
  allocationTotalTable: {
    marginTop: '4px',
    padding: '0 24px 0 24px'
  },
  allocationTotalTableContent: {
    borderRadius: '2px',
    '& .MuiTableRow-root': {
      backgroundColor: palette.shades[200]
    },
    '& .MuiTableCell-root': {
      fontSize: '13px',
      padding: '8px 5px'
    }
  },
  comparisonBox: {
    zIndex: '10',
    right: '16px',
    width: '848px',
    bottom: '90px',
    borderRadius: '2px',
    position: 'absolute',
    backgroundColor: palette.common.white,
    border: "1px solid ".concat(palette.shades[300]),
    boxShadow: '0px 18px 32px 0px rgba(0, 0, 0, 0.15)'
  },
  comparisonBoxTitle: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& .MuiTypography-root': {
      color: palette.common.black
    }
  },
  comparisonBoxCaption: {
    padding: '8px',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  comparisonBoxWarning: {
    display: 'flex',
    fontSize: '13px',
    color: palette.warning.dark,
    fontWeight: '600',
    padding: '6px 10px',
    alignItems: 'center',
    backgroundColor: palette.warning.light,
    justifyContent: 'flex-start',
    fontFamily: palette.fontFamilies.poppins,
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      marginRight: '4px'
    }
  },
  comparisonBoxTable: {
    '& .MuiTableCell-root': {
      padding: '12px 8px'
    },
    '& .MuiTableContainer-root': {
      boxShadow: 'none'
    }
  },
  comparisonBoxFooter: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  gwdBox: {
    top: 0,
    right: 0,
    width: '410px',
    maxWidth: '100%',
    zIndex: '9999',
    display: 'flex',
    borderRadius: '2px',
    position: 'absolute',
    flexDirection: 'column',
    backgroundColor: palette.common.white,
    boxShadow: '0px 18px 32px 0px rgba(0, 0, 0, 0.15)',
    '&:after': {
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      zIndex: '-1',
      content: '""',
      display: 'block',
      position: 'fixed',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  gwdBoxValue: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '14px',
    justifyContent: 'space-between'
  },
  gwdBoxHeader: {
    display: 'flex',
    fontSize: '15px',
    fontWeight: '600',
    padding: '12px 16px',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    fontFamily: palette.fontFamilies.poppins
  },
  gwdBoxForm: {
    padding: '16px',
    backgroundColor: palette.common.white,
    '& .MuiAlert-root': {
      padding: '8px'
    }
  },
  gwdBoxFormValue: {
    maxWidth: '100px',
    marginBottom: '10px'
  },
  gwdBoxFormItem: {
    marginBottom: '10px'
  },
  gwdBoxFormInfo: {
    display: 'flex',
    color: palette.info.dark,
    fontSize: '14px',
    lineHeight: '21px',
    marginBottom: '10px',
    padding: '6px 10px',
    borderRadius: '2px',
    backgroundColor: palette.info.light,
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      marginTop: '2px',
      marginRight: '4px'
    }
  },
  gwdBoxFormActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  gwdBoxList: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    backgroundColor: ' #F8F9FA',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  gwdBoxListTitle: {
    color: palette.shades[700],
    fontSize: '13px',
    fontWeight: '600',
    padding: '12px 16px 4px 16px',
    fontFamily: palette.fontFamilies.poppins
  },
  gwdBoxListItems: {},
  gwdBoxListItem: {
    padding: '8px 16px',
    '&:not(:first-child)': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  gwdBoxListItemTitle: {
    display: 'flex',
    marginBottom: '2px',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& b': {
      fontSize: '13px',
      fontWeight: '600',
      fontFamily: palette.fontFamilies.poppins,
      '& span': {
        color: palette.shades[700]
      }
    }
  },
  gwdBoxListItemBody: {
    fontSize: '11px',
    lineHeight: '14px',
    '& span': {
      color: palette.shades[700]
    }
  },
  visibilitySetting: {
    left: '0',
    bottom: '0',
    zIndex: '9',
    display: 'flex',
    position: 'absolute',
    backgroundColor: 'white',
    height: 'auto !important',
    padding: '12px 16px 12px 16px',
    width: 'calc(50% - 1px) !important',
    '& .MuiFormControlLabel-label': {
      marginRight: '0px'
    }
  },
  visibilitySettingWithUtilitySwitcher: {
    left: 0,
    width: 'auto !important'
  },
  customChargeOnDateDatePicker: {
    marginTop: '10px',
    width: '300px',
    marginRight: '10px',
    display: 'flex'
  },
  utilitySwitcher: {
    display: 'flex',
    padding: '16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  /** When `FileVisibilitySetting` is shown (file preview + visibility row in FileDetails). */
  utilitySwitcherWithFileVisibility: {
    paddingLeft: '400px'
  },
  attachFileControllersDivider: {
    margin: '8px 0',
    fontSize: '14px'
  },
  totalToAllocateAmountRow: {
    marginTop: '12px'
  },
  totalToAllocateAmountEditButton: {
    marginLeft: '8px'
  },
  pushApButton: {
    marginRight: '16px'
  },
  pushApInfoIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: '6px',
    cursor: 'pointer'
  },
  attachFileLinkButton: {
    fontSize: '13px',
    cursor: 'pointer',
    fontWeight: '600',
    textDecoration: 'underline',
    color: palette.primary.main,
    fontFamily: palette.fontFamilies.poppins,
    '&:hover': {
      opacity: '0.8'
    }
  }
}));
export default useStyles;